import Axios from "axios";
import * as EndPoints from "./restEndPoints";
import { GetCurrentUser, SignOut } from "../firebase/auth";

// console.log('current user', GetCurrentUser())

Axios.interceptors.request.use(
    async (config) => {
        // Get the current user from Firebase
        const user = GetCurrentUser();

        if (user) {
            // Get the Firebase ID token
            const token = await user.getIdToken();

            // Add the token to the request headers
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        // Do something with request error
        return Promise.reject(error);
    }
);

Axios.interceptors.response.use(
    (response) => {
        // Do something with response data
        return response;
    },
    (error) => {
        // Check if error is due to 401 Unauthorized
        if (error.response && error.response.status === 401) {
            console.log('Unauthorized request detected, logging out user');
            // Call the logout function
            SignOut().then(() => {
                // Redirect to login page
                window.location.href = '/auth';
            });
        }
        // Do something with response error
        return Promise.reject(error);
    }
);


// * ------------------------------------------------------------------------------ Branch Apis
export const AddNewBranch = (data) => {
    return Axios.post(EndPoints.Post_addBranch, data);
};

export const GetAllBranches = () => {
    return Axios.get(EndPoints.Get_getBranches);
};

export const UpdateBranch = (branchId, data) => {
    return Axios.put(EndPoints.Put_updateBranch(branchId), data);
}

export const GetBranchById = (branchId) => {
    return Axios.get(EndPoints.Get_getBranchById(branchId));
}

export const DeleteBranch = (branchId) => {
    return Axios.delete(EndPoints.Delete_deleteBranch(branchId));
}

// * ------------------------------------------------------------------------------ Buildings Apis
export const AddNewBuilding = (branchId, data) => {
    return Axios.post(EndPoints.Post_addBuilding(branchId), data);
};

export const GetBuildings = (branchId = 'all') => {
    return Axios.get(EndPoints.Get_getBuildings(branchId));
};

export const UpdateBuilding = (buildingId, data) => {
    return Axios.put(EndPoints.Put_updateBuilding(buildingId), data);
}

export const GetBuildingById = (buildingId) => {
    return Axios.get(EndPoints.Get_getBuildingById(buildingId));
}

export const DeleteBuilding = (buildingId) => {
    return Axios.delete(EndPoints.Delete_deleteBuilding(buildingId));
}

// * ------------------------------------------------------------------------------ Floors Apis
export const AddNewFloor = (buildingId, data) => {
    return Axios.post(EndPoints.Post_addFloor(buildingId), data);
};

export const GetFloors = (buildingId = 'all', filters = {}) => {
    return Axios.get(EndPoints.Get_getFloors(buildingId), { params: filters });
};

export const GetFloorOptions = () => {
    return Axios.get(EndPoints.Get_getFloorOptions());
};

export const GetFloorById = (floorId) => {
    return Axios.get(EndPoints.Get_getFloorById(floorId));
}

export const UpdateFloor = (floorId, data) => {
    return Axios.put(EndPoints.Put_updateFloor(floorId), data);
}

export const DeleteFloor = (floorId) => {
    return Axios.delete(EndPoints.Delete_deleteFloor(floorId));
}

// * ------------------------------------------------------------------------------ Offices Apis
export const AddNewOffice = (floorId, data) => {
    return Axios.post(EndPoints.Post_addOffice(floorId), data);
};

export const GetOffices = (floorId = 'all', filters = {}) => {
    return Axios.get(EndPoints.Get_getOffices(floorId), { params: filters });
};

export const GetOfficeById = (officeId) => {
    return Axios.get(EndPoints.Get_getOfficeById(officeId));
}

export const UpdateOffice = (officeId, data) => {
    return Axios.put(EndPoints.Put_updateOffice(officeId), data);
}

export const DeleteOffice = (officeId) => {
    return Axios.delete(EndPoints.Delete_deleteOffice(officeId));
}

// * ------------------------------------------------------------------------------ Coworking Space Apis
export const AddNewCoworkingSpace = (floorId, data) => {
    return Axios.post(EndPoints.Post_addCoWorkingSpace(floorId), data);
};

export const GetCoworkingSpaces = (floorId = 'all') => {
    return Axios.get(EndPoints.Get_getCoWorkingSpaces(floorId));
};

export const GetCoworkingSpaceById = (spaceId) => {
    return Axios.get(EndPoints.Get_getCoWorkingSpaceById(spaceId));
}

export const UpdateCoworkingSpace = (spaceId, data) => {
    return Axios.put(EndPoints.Put_updateCoworkingSpaces(spaceId), data);
}

export const DeleteCoworkingSpace = (spaceId) => {
    return Axios.delete(EndPoints.Delete_deleteCoworkingSpace(spaceId));
}

// *  ------------------------------------------------------------------------------ Seats Apis
export const AddNewSeat = (spaceId, data) => {
    return Axios.post(EndPoints.Post_addSeat(spaceId), data);
};

export const GetSeats = (spaceId = 'all', filters = {}) => {
    return Axios.get(EndPoints.Get_getSeats(spaceId), { params: filters });
};

export const GetSeatById = (seatId) => {
    return Axios.get(EndPoints.Get_getSeatById(seatId));
}

export const UpdateSeat = (seatId, data) => {
    return Axios.put(EndPoints.Put_updateSeat(seatId), data);
}

export const DeleteSeat = (seatId) => {
    return Axios.delete(EndPoints.Delete_deleteSeat(seatId));
}

export const PatchUpdateSeatStatus = (seatId, data) => {
    return Axios.patch(EndPoints.Patch_updateSeatStatus(seatId), data);
}


// * ------------------------------------------------------------------------------ Users Apis
export const AddNewUser = (data) => {
    return Axios.post(EndPoints.Post_addUser, data);
}
export const GetAllUsers = (filters) => {
    return Axios.get(EndPoints.Get_getUsers, { params: filters });
}

export const GetUserById = (userId) => {
    return Axios.get(EndPoints.Get_getUserById(userId));
}

export const DeleteUser = (userId) => {
    return Axios.delete(EndPoints.Delete_deleteUser(userId));
}

export const DeleteTeamMember = (userId) => {
    return Axios.delete(EndPoints.Delete_deleteTeamMember(userId));
}

export const UpdateUser = (userId, data) => {
    return Axios.put(EndPoints.Put_updateUser(userId), data);
}

export const UpdateTeamMemberPermissions = (userId, data) => {
    return Axios.put(EndPoints.Put_updateTeamMemberPermissions(userId), data);
}

export const LoginUser = (data) => {
    return Axios.post(EndPoints.Post_loginUser, data);
}

export const UpdateUserMeetingRoomQuota = (userId, data) => {
    return Axios.put(EndPoints.Put_updateMeetingRoomQuota(userId), data);
}

export const UpdateTeamMemberMeetingRoomQuota = (userId, data) => {
    return Axios.put(EndPoints.Put_updateTeamMemberMeetingRoomQuota(userId), data);
}

export const GetMeetingRoomQuotaDefaults = () => {
    return Axios.get(EndPoints.Get_getMeetingRoomQuotaDefaults);
}

export const UpdateMeetingRoomQuotaDefaults = (data) => {
    return Axios.put(EndPoints.Put_updateMeetingRoomQuotaDefaults, data);
}

export const ExportSecurityCsvTemplate = () => {
    return Axios.get(EndPoints.Get_exportSecurityCsvTemplate, { responseType: 'blob' });
}

export const DryRunSecurityCsvImport = (payload) => {
    return Axios.post(EndPoints.Post_dryRunSecurityCsvImport, payload);
}

export const ApplySecurityCsvImport = (payload) => {
    return Axios.post(EndPoints.Post_applySecurityCsvImport, payload);
}

export const UpdateUserStatus = (userId, status) => {
    return Axios.put(EndPoints.Put_updateUserStatus(userId), { enabled: status });
}

export const SendResetPasswordEmail = (userId) => {
    return Axios.post(EndPoints.Post_sendResetPasswordEmail(userId));
}

export const RequestPasswordReset = (email) => {
    return Axios.post(EndPoints.Post_requestPasswordReset, { email });
}

export const CompletePasswordReset = (email) => {
    return Axios.post(EndPoints.Post_completePasswordReset, { email });
}

export const ForceResetPassword = (userId, password) => {
    return Axios.post(EndPoints.Post_forceResetPassword(userId), { password });
}

export const RevealPassword = (userId) => {
    return Axios.get(EndPoints.Get_revealPassword(userId));
}

export const MarkPasswordChanged = () => {
    return Axios.post(EndPoints.Post_markPasswordChanged);
}

// * ------------------------------------------------------------------------------ Booking Apis
export const AddNewBooking = (data) => {
    return Axios.post(EndPoints.Post_addBooking, data);
};

export const GetAllBookings = () => {
    return Axios.get(EndPoints.Get_getBookings);
};

export const GetBookingById = (bookingId) => {
    return Axios.get(EndPoints.Get_getBookingById(bookingId));
}

export const UpdateBooking = (bookingId, data) => {
    return Axios.put(EndPoints.Put_updateBooking(bookingId), data);
}

export const DeleteBooking = (bookingId) => {
    return Axios.delete(EndPoints.Delete_deleteBooking(bookingId));
}

export const PatchUpdateBookingStatus = (bookingId, data) => {
    return Axios.patch(EndPoints.Patch_updateBookingStatus(bookingId), data);
}

export const GetBookingsByContract = (contractId) => {
    return Axios.get(EndPoints.Get_getBookingsByContract(contractId));
}

export const GetBookingsByUser = (userId) => {
    return Axios.get(EndPoints.Get_getBookingsByUser(userId));
}

export const GetBookingsBySeat = (seatId) => {
    return Axios.get(EndPoints.Get_getBookingsBySeat(seatId));
}

// * ------------------------------------------------------------------------------ Contract Apis
export const AddNewContract = (data) => {
    return Axios.post(EndPoints.Post_addContract, data);
};

export const GetContracts = (filters = {}) => {
    return Axios.get(EndPoints.Get_getContracts, { params: filters });
};

export const GetContractByUserId = (userId) => {
    return Axios.get(EndPoints.Get_getUserContracts(userId));
}

export const UpdateContract = (contractId, data) => {
    return Axios.put(EndPoints.Put_updateContract(contractId), data);
}

export const DeleteContract = (contractId) => {
    return Axios.delete(EndPoints.Delete_deleteContract(contractId));
}

export const GetUserOwnContracts = () => {
    return Axios.get(EndPoints.Get_getUserOwnContracts);
}

export const UpdateContractWithCompletedBookings = (contractId, data) => {
    return Axios.patch(EndPoints.Patch_updateContractWithCompletedBookings(contractId), data);
}

export const FreezeBooking = (bookingId, data) => {
    return Axios.patch(EndPoints.Patch_freezeBooking(bookingId), data);
}

export const UnfreezeBooking = (bookingId) => {
    return Axios.patch(EndPoints.Patch_unfreezeBooking(bookingId));
}

export const UpdateFreezeDates = (bookingId, data) => {
    return Axios.patch(EndPoints.Patch_updateFreezeDates(bookingId), data);
}

// * ------------------------------------------------------------------------------ Meetings Room Apis
export const AddNewMeetingRoom = (floorId, data) => {
    return Axios.post(EndPoints.Post_addMeetingRoom(floorId), data);
}

export const GetMeetingRooms = (floorId = 'all') => {
    return Axios.get(EndPoints.Get_getMeetingRooms(floorId));
}

export const UpdateMeetingRoom = (meetingRoomId, data) => {
    return Axios.put(EndPoints.Put_updateMeetingRoom(meetingRoomId), data);
}

export const DeleteMeetingRoom = (meetingRoomId) => {
    return Axios.delete(EndPoints.Delete_deleteMeetingRoom(meetingRoomId));
}

// * ------------------------------------------------------------------------------ Meeting Room Booking Apis
export const AddNewMeetingRoomBooking = (data) => {
    return Axios.post(EndPoints.Post_addMeetingRoomBooking, data);
}

export const GetMeetingRoomBookings = () => {
    return Axios.get(EndPoints.Get_getMeetingRoomBookings);
}

export const UpdateMeetingRoomBooking = (bookingId, data) => {
    return Axios.put(EndPoints.Put_updateMeetingRoomBooking(bookingId), data);
}

export const CancelMeetingRoomBooking = (bookingId) => {
    return Axios.put(EndPoints.Put_cancelMeetingRoomBooking(bookingId));
}

export const AddTeamMemberMeetingRoomBooking = (data) => {
    return Axios.post(EndPoints.Post_addTeamMemberMeetingRoomBooking, data);
}

// export const DeleteMeetingRoomBooking = (bookingId) => {
//     return Axios.delete(EndPoints.Delete_deleteMeetingRoomBooking(bookingId));
// }

// * ------------------------------------------------------------------------------ Stats Apis
export const GetStats = () => {
    return Axios.get(EndPoints.Get_getDashboardStats);
}

export const ForceUpdateStats = () => {
    return Axios.post(EndPoints.Post_refreshDashboardStats);
}

export const GetCustomerDashboardStats = () => {
    return Axios.get(EndPoints.Get_getCustomerDashboardStats);
}

export const GetTeamMemberDashboardStats = () => {
    return Axios.get(EndPoints.Get_getTeamMemberDashboardStats);
}

export const GetRentBreakdown = () => {
    return Axios.get(EndPoints.Get_getRentBreakdown);
}

export const GetSecurityBreakdown = () => {
    return Axios.get(EndPoints.Get_getSecurityBreakdown);
}

export const GetCustomersStats = () => {
    return Axios.get(EndPoints.Get_getCustomersStats);
}

// * ------------------------------------------------------------------------------ Lead Apis
export const AddNewLead = (data) => {
    return Axios.post(EndPoints.Post_addLead, data);
}

export const GetLeads = (filters = {}) => {
    return Axios.get(EndPoints.Get_getLeads, { params: filters });
}

export const GetLeadById = (leadId) => {
    return Axios.get(EndPoints.Get_getLeadById(leadId));
}

export const UpdateLead = (leadId, data) => {
    return Axios.put(EndPoints.Put_updateLead(leadId), data);
}

export const AddEngagement = (leadId, data) => {
    return Axios.post(EndPoints.Post_addEngagement(leadId), data);
}

export const UpdateEngagement = (leadId, engagementId, data) => {
    return Axios.put(EndPoints.Put_updateEngagement(leadId, engagementId), data);
}

export const GetLeadsByRep = (repId) => {
    return Axios.get(EndPoints.Get_getLeadsByRep(repId));
}

export const DeleteLead = (leadId) => {
    return Axios.delete(EndPoints.Delete_deleteLead(leadId));
}

export const AddTeamMemberByAdmin = (data) => {
    return Axios.post(EndPoints.Post_addTeamMemberByAdmin, data);
}

export const AddTeamMember = (data) => {
    return Axios.post(EndPoints.Post_addTeamMember, data);
}

// * ------------------------------------------------------------------------------ Quotation Apis
export const GetQuotationDefaults = () => {
    return Axios.get(EndPoints.Get_getQuotationDefaults);
}

export const UpdateQuotationDefaults = (data) => {
    return Axios.put(EndPoints.Put_updateQuotationDefaults, data);
}

export const GetQuotationsByLead = (leadId) => {
    return Axios.get(EndPoints.Get_getQuotationsByLead(leadId));
}

export const CreateQuotation = (leadId, data) => {
    return Axios.post(EndPoints.Post_createQuotation(leadId), data);
}

export const GetQuotationById = (quotationId) => {
    return Axios.get(EndPoints.Get_getQuotationById(quotationId));
}

export const UpdateQuotation = (quotationId, data) => {
    return Axios.put(EndPoints.Put_updateQuotation(quotationId), data);
}

export const DeleteQuotation = (quotationId) => {
    return Axios.delete(EndPoints.Delete_deleteQuotation(quotationId));
}

// * ------------------------------------------------------------------------------ Role Apis (RBAC)
export const CreateRole = (data) => {
    return Axios.post(EndPoints.Post_createRole, data);
}

export const GetRoles = () => {
    return Axios.get(EndPoints.Get_getRoles);
}

export const GetRoleById = (roleId) => {
    return Axios.get(EndPoints.Get_getRoleById(roleId));
}

export const UpdateRole = (roleId, data) => {
    return Axios.put(EndPoints.Put_updateRole(roleId), data);
}

export const DeleteRole = (roleId) => {
    return Axios.delete(EndPoints.Delete_deleteRole(roleId));
}


// * ------------------------------------------------------------------------------ Customer Support Apis
export const CreateTicket = (data) => {
    return Axios.post(EndPoints.Post_createTicket, data);
}

export const GetTickets = () => {
    return Axios.get(EndPoints.Get_getTickets);
}

export const GetTicketById = (ticketId) => {
    return Axios.get(EndPoints.Get_getTicketById(ticketId));
}

export const AddInteraction = (ticketId, data) => {
    return Axios.post(EndPoints.Post_addInteraction(ticketId), data);
}

export const AcknowledgeResolution = (ticketId) => {
    return Axios.post(EndPoints.Post_acknowledgeResolution(ticketId));
}

export const SubmitFeedback = (ticketId, data) => {
    return Axios.post(EndPoints.Post_submitFeedback(ticketId), data);
}

// * ------------------------------------------------------------------------------ Support Apis
export const GetSupportTickets = () => {
    return Axios.get(EndPoints.Get_getTickets);
}

export const GetSupportTicketById = (ticketId) => {
    return Axios.get(EndPoints.Get_getTicketById(ticketId));
}

export const AddSupportTicket = (data) => {
    return Axios.post(EndPoints.Post_createTicket, data);
}

export const UpdateSupportTicket = (ticketId, data) => {
    return Axios.put(EndPoints.Put_updateTicket(ticketId), data);
}

export const DeleteSupportTicket = (ticketId) => {
    return Axios.delete(EndPoints.Delete_deleteTicket(ticketId));
}

export const GetSupportTicketInteractions = (ticketId) => {
    return Axios.get(EndPoints.Get_getInteractions(ticketId));
}

export const AddSupportTicketInteraction = (ticketId, data) => {
    return Axios.post(EndPoints.Post_addInteraction(ticketId), data);
}

export const AcknowledgeSupportTicketResolution = (ticketId, data) => {
    return Axios.post(EndPoints.Post_acknowledgeResolution(ticketId), data);
}

export const ApproveSupportTicket = (ticketId) => {
    return Axios.put(EndPoints.Put_approveTicket(ticketId));
}

export const SubmitSupportTicketFeedback = (ticketId, data) => {
    return Axios.post(EndPoints.Post_submitFeedback(ticketId), data);
}

export const GetAllTickets = (filters = {}) => {
    return Axios.get(EndPoints.Get_getAllTickets, { params: filters });
}

export const GetTicketDetails = (ticketId) => {
    return Axios.get(EndPoints.Get_getTicketDetails(ticketId));
}

export const GetSupportSettings = () => {
    return Axios.get(EndPoints.Get_getSupportSettings);
}

export const UpdateSupportSettings = (data) => {
    return Axios.put(EndPoints.Put_updateSupportSettings, data);
}

export const UpdateTicketStatus = (ticketId, data) => {
    return Axios.put(EndPoints.Put_updateTicketStatus(ticketId), data);
}

export const AssignTicket = (ticketId, data) => {
    return Axios.put(EndPoints.Put_assignTicket(ticketId), data);
}

export const CreateTicketByAdmin = (data) => {
    return Axios.post(EndPoints.Post_createTicketByAdmin, data);
}

export const UpdateTicketDueDate = (ticketId, data) => {
    return Axios.put(EndPoints.Put_updateTicketDueDate(ticketId), data);
}

export const UpdateTicketPriority = (ticketId, data) => {
    return Axios.put(EndPoints.Put_updateTicketPriority(ticketId), data);
}

export const UpdateTicketLocation = (ticketId, data) => {
    return Axios.put(EndPoints.Put_updateTicketLocation(ticketId), data);
}

export const GetSupportDashboard = () => {
    return Axios.get(EndPoints.Get_supportDashboard);
}

export const GetSupportTrend = (params) => {
    return Axios.get(EndPoints.Get_supportTrend, { params });
}

export const GetSupportCategories = (params) => {
    return Axios.get(EndPoints.Get_supportCategories, { params });
}

export const CreateSupportCategory = (data) => {
    return Axios.post(EndPoints.Post_createSupportCategory, data);
}

export const UpdateSupportCategory = (categoryId, data) => {
    return Axios.put(EndPoints.Put_updateSupportCategory(categoryId), data);
}

export const DeleteSupportCategory = (categoryId) => {
    return Axios.delete(EndPoints.Delete_supportCategory(categoryId));
}

// * ------------------------------------------------------------------------------ Day Pass Apis
export const CreateDayPass = (data) => {
    return Axios.post(EndPoints.Post_createDayPass, data);
}

export const GetDayPasses = () => {
    return Axios.get(EndPoints.Get_getDayPasses);
}

export const GetDayPassById = (dayPassId) => {
    return Axios.get(EndPoints.Get_getDayPassById(dayPassId));
}

export const UpdateDayPass = (dayPassId, data) => {
    return Axios.put(EndPoints.Put_updateDayPass(dayPassId), data);
}

export const CompleteDayPass = (dayPassId, data) => {
    return Axios.patch(EndPoints.Patch_completeDayPass(dayPassId), data);
}

export const ApproveDayPass = (dayPassId, data) => {
    return Axios.patch(EndPoints.Patch_approveDayPass(dayPassId), data);
}

export const CheckInDayPass = (dayPassId, data) => {
    return Axios.patch(EndPoints.Patch_checkInDayPass(dayPassId), data);
}

export const CheckOutDayPass = (dayPassId, data) => {
    return Axios.patch(EndPoints.Patch_checkOutDayPass(dayPassId), data);
}

export const UpdateDayPassPaymentStatus = (dayPassId, data) => {
    return Axios.patch(EndPoints.Patch_updateDayPassPaymentStatus(dayPassId), data);
}

export const GetDayPassesByDate = (date) => {
    return Axios.get(EndPoints.Get_getDayPassesByDate(date));
}

export const GetDayPassesByCustomerEmail = (email) => {
    return Axios.get(EndPoints.Get_getDayPassesByCustomerEmail(email));
}

export const GetDayPassesByCustomerId = (customerId) => {
    return Axios.get(EndPoints.Get_getDayPassesByCustomerId(customerId));
}

export const CancelDayPass = (dayPassId, data) => {
    return Axios.patch(EndPoints.Patch_cancelDayPass(dayPassId), data);
}

export const ExtendDayPass = (dayPassId, data) => {
    return Axios.patch(EndPoints.Patch_extendDayPass(dayPassId), data);
}

// * ------------------------------------------------------------------------------ Notification Apis
export const GetUserNotifications = () => {
    return Axios.get(EndPoints.Get_getUserNotifications);
}

export const MarkNotificationRead = (notificationId, data) => {
    return Axios.patch(EndPoints.Patch_markNotificationRead(notificationId), data);
}

export const MarkAllNotificationsRead = () => {
    return Axios.patch(EndPoints.Patch_markAllNotificationsRead);
}

export const GetUnreadNotificationCount = () => {
    return Axios.get(EndPoints.Get_getUnreadNotificationCount);
}

// * ------------------------------------------------------------------------------ Impersonation Apis
export const StartImpersonation = (data) => {
    return Axios.post(EndPoints.Post_startImpersonation, data);
}

export const StopImpersonation = (data) => {
    return Axios.post(EndPoints.Post_stopImpersonation, data);
}

// * ------------------------------------------------------------------------------ Invoice Apis
export const GetInvoices = (params) => {
    return Axios.get(EndPoints.Get_getInvoices, { params });
}

export const GetInvoiceById = (invoiceId) => {
    return Axios.get(EndPoints.Get_getInvoiceById(invoiceId));
}

export const GetInvoiceStats = () => {
    return Axios.get(EndPoints.Get_getInvoiceStats);
}

export const GetInvoiceSettings = () => {
    return Axios.get(EndPoints.Get_getInvoiceSettings);
}

export const UpdateInvoiceSettings = (data) => {
    return Axios.put(EndPoints.Put_updateInvoiceSettings, data);
}

export const GenerateInvoices = (data) => {
    return Axios.post(EndPoints.Post_generateInvoices, data);
}

export const UpdateInvoiceStatus = (invoiceId, data) => {
    return Axios.patch(EndPoints.Patch_updateInvoiceStatus(invoiceId), data);
}

export const AddInvoicePayment = (invoiceId, data) => {
    return Axios.post(EndPoints.Post_addInvoicePayment(invoiceId), data);
}

export const CustomerMarkInvoicePaid = (invoiceId, data) => {
    return Axios.post(EndPoints.Post_customerMarkInvoicePaid(invoiceId), data);
}

export const ApproveInvoicePayment = (invoiceId, paymentIndex) => {
    return Axios.patch(EndPoints.Patch_approveInvoicePayment(invoiceId, paymentIndex));
}

export const RejectInvoicePayment = (invoiceId, paymentIndex) => {
    return Axios.patch(EndPoints.Patch_rejectInvoicePayment(invoiceId, paymentIndex));
}

export const SyncInvoice = (invoiceId) => {
    return Axios.post(EndPoints.Post_syncInvoice(invoiceId));
}

export const UpdateInvoiceDueDate = (invoiceId, data) => {
    return Axios.patch(EndPoints.Patch_updateInvoiceDueDate(invoiceId), data);
}

export const UpdateInvoice = (invoiceId, data) => {
    return Axios.put(EndPoints.Put_updateInvoice(invoiceId), data);
}

export const UpdateInvoicePayment = (invoiceId, paymentIndex, data) => {
    return Axios.patch(EndPoints.Patch_updateInvoicePayment(invoiceId, paymentIndex), data);
}

export const DeleteInvoicePayment = (invoiceId, paymentIndex) => {
    return Axios.delete(EndPoints.Delete_invoicePayment(invoiceId, paymentIndex));
}

export const CreateManualInvoice = (data) => {
    return Axios.post(EndPoints.Post_createManualInvoice, data);
}

// * ------------------------------------------------------------------------------ Bank Apis
export const GetBanks = (params) => {
    return Axios.get(EndPoints.Get_getBanks, { params });
}

export const GetBankById = (bankId) => {
    return Axios.get(EndPoints.Get_getBankById(bankId));
}

export const AddBank = (data) => {
    return Axios.post(EndPoints.Post_addBank, data);
}

export const UpdateBank = (bankId, data) => {
    return Axios.put(EndPoints.Put_updateBank(bankId), data);
}

export const DeleteBank = (bankId) => {
    return Axios.delete(EndPoints.Delete_deleteBank(bankId));
}

// * ------------------------------------------------------------------------------ Refund Apis
export const GetRefunds = (params) => {
    return Axios.get(EndPoints.Get_getRefunds, { params });
}

export const GetRefundById = (refundId) => {
    return Axios.get(EndPoints.Get_getRefundById(refundId));
}

export const AddRefund = (data) => {
    return Axios.post(EndPoints.Post_addRefund, data);
}

export const UpdateRefund = (refundId, data) => {
    return Axios.put(EndPoints.Put_updateRefund(refundId), data);
}

export const DeleteRefund = (refundId) => {
    return Axios.delete(EndPoints.Delete_deleteRefund(refundId));
}

// * ------------------------------------------------------------------------------ Inventory Apis
export const GetInventoryDashboard = () => {
    return Axios.get(EndPoints.Get_getInventoryDashboard);
}

export const GetInventoryItems = (filters = {}) => {
    return Axios.get(EndPoints.Get_getInventoryItems, { params: filters });
}

export const AddInventoryItem = (data) => {
    return Axios.post(EndPoints.Post_addInventoryItem, data);
}

export const GetInventoryItemById = (itemId) => {
    return Axios.get(EndPoints.Get_getInventoryItemById(itemId));
}

export const UpdateInventoryItem = (itemId, data) => {
    return Axios.put(EndPoints.Put_updateInventoryItem(itemId), data);
}

export const DeleteInventoryItem = (itemId) => {
    return Axios.delete(EndPoints.Delete_deleteInventoryItem(itemId));
}

export const GetInventoryItemHistory = (itemId) => {
    return Axios.get(EndPoints.Get_getInventoryItemHistory(itemId));
}

export const ExportInventoryItemCsv = (itemId) => {
    return Axios.get(EndPoints.Get_exportInventoryItemCsv(itemId), { responseType: 'blob' });
}

export const GetInventoryTransactions = (itemId, filters = {}) => {
    return Axios.get(EndPoints.Get_getInventoryTransactions(itemId), { params: filters });
}

export const AddInventoryTransaction = (itemId, data) => {
    return Axios.post(EndPoints.Post_addInventoryTransaction(itemId), data);
}

export const GetInventoryPhysicalCounts = (itemId) => {
    return Axios.get(EndPoints.Get_getInventoryPhysicalCounts(itemId));
}

export const AddInventoryPhysicalCount = (itemId, data) => {
    return Axios.post(EndPoints.Post_addInventoryPhysicalCount(itemId), data);
}

export const GetInventoryConsumers = (filters = {}) => {
    return Axios.get(EndPoints.Get_getInventoryConsumers, { params: filters });
}

export const AddInventoryConsumer = (data) => {
    return Axios.post(EndPoints.Post_addInventoryConsumer, data);
}

export const UpdateInventoryConsumer = (consumerId, data) => {
    return Axios.put(EndPoints.Put_updateInventoryConsumer(consumerId), data);
}

export const DeleteInventoryConsumer = (consumerId) => {
    return Axios.delete(EndPoints.Delete_deleteInventoryConsumer(consumerId));
}

export const GetInventoryConsumptionTrend = (filters = {}) => {
    return Axios.get(EndPoints.Get_getInventoryConsumptionTrend, { params: filters });
}

export const GetInventoryConsumptionByFloor = (filters = {}) => {
    return Axios.get(EndPoints.Get_getInventoryConsumptionByFloor, { params: filters });
}

export const GetInventoryFloorItemBreakdown = (filters = {}) => {
    return Axios.get(EndPoints.Get_getInventoryFloorItemBreakdown, { params: filters });
}

export const GetInventoryBreakageReport = (filters = {}) => {
    return Axios.get(EndPoints.Get_getInventoryBreakageReport, { params: filters });
}

export const GetInventoryLowStockReport = () => {
    return Axios.get(EndPoints.Get_getInventoryLowStockReport);
}

export const GetInventoryCountMismatchesReport = () => {
    return Axios.get(EndPoints.Get_getInventoryCountMismatchesReport);
}

export const ExportAllInventoryItemsCsv = () => {
    return Axios.get(EndPoints.Get_exportAllInventoryItemsCsv, { responseType: 'blob' });
}

export const ExportAllInventoryTransactionsCsv = () => {
    return Axios.get(EndPoints.Get_exportAllInventoryTransactionsCsv, { responseType: 'blob' });
}

export const GetInventoryCsvTemplate = () => {
    return Axios.get(EndPoints.Get_getInventoryCsvTemplate, { responseType: 'blob' });
}

export const DryRunInventoryCsvImport = (data) => {
    return Axios.post(EndPoints.Post_dryRunInventoryCsvImport, data);
}

export const ApplyInventoryCsvImport = (data) => {
    return Axios.post(EndPoints.Post_applyInventoryCsvImport, data);
}

// ** ----------------------------------------------------------------------------------------------------- Maintenance
export const GetMaintenanceSummary = () => {
    return Axios.get(EndPoints.Get_getMaintenanceSummary);
}

export const GetMaintenanceReports = () => {
    return Axios.get(EndPoints.Get_getMaintenanceReports);
}

export const GetMaintenanceWorkOrders = (filters = {}) => {
    return Axios.get(EndPoints.Get_getMaintenanceWorkOrders, { params: filters });
}

export const AddMaintenanceWorkOrder = (data) => {
    return Axios.post(EndPoints.Post_addMaintenanceWorkOrder, data);
}

export const GetMaintenanceWorkOrderById = (workOrderId) => {
    return Axios.get(EndPoints.Get_getMaintenanceWorkOrderById(workOrderId));
}

export const UpdateMaintenanceWorkOrder = (workOrderId, data) => {
    return Axios.put(EndPoints.Put_updateMaintenanceWorkOrder(workOrderId), data);
}

export const UpdateMaintenanceWorkOrderStatus = (workOrderId, data) => {
    return Axios.patch(EndPoints.Patch_updateMaintenanceWorkOrderStatus(workOrderId), data);
}

export const UpdateMaintenanceWorkOrderCost = (workOrderId, data) => {
    return Axios.patch(EndPoints.Patch_updateMaintenanceWorkOrderCost(workOrderId), data);
}

export const DeleteMaintenanceWorkOrder = (workOrderId) => {
    return Axios.delete(EndPoints.Delete_deleteMaintenanceWorkOrder(workOrderId));
}

export const GetMaintenanceInteractions = (workOrderId) => {
    return Axios.get(EndPoints.Get_getMaintenanceInteractions(workOrderId));
}

export const AddMaintenanceInteraction = (workOrderId, data) => {
    return Axios.post(EndPoints.Post_addMaintenanceInteraction(workOrderId), data);
}

// * ------------------------------------------------------------------------------ Executive dashboard (snapshot DB)
export const GetExecutiveRange = (params = {}) => {
    return Axios.get(EndPoints.Get_getExecutiveRange, { params });
}

export const RefreshExecutiveToday = (params = {}) => {
    return Axios.post(EndPoints.Post_refreshExecutiveToday, null, { params });
}

export const ListExecutiveSnapshots = () => {
    return Axios.get(EndPoints.Get_listExecutiveSnapshots);
}

// * ------------------------------------------------------------------------------ Finance archive (WBP-188 RO)
export const GetFinanceArchiveMeta = () => {
    return Axios.get(EndPoints.Get_financeArchiveMeta);
};

export const SearchFinanceArchiveTransactions = (params = {}) => {
    return Axios.get(EndPoints.Get_financeArchiveTransactions, { params });
};

export const GetFinanceArchiveTransaction = (sourceId) => {
    return Axios.get(EndPoints.Get_financeArchiveTransaction(sourceId));
};

export const SearchFinanceArchiveAccounts = (params = {}) => {
    return Axios.get(EndPoints.Get_financeArchiveAccounts, { params });
};

export const SearchFinanceArchiveContacts = (params = {}) => {
    return Axios.get(EndPoints.Get_financeArchiveContactsAutocomplete, { params });
};

export const SearchFinanceArchiveDocuments = (params = {}) => {
    return Axios.get(EndPoints.Get_financeArchiveDocuments, { params });
};

export const DownloadFinanceArchiveDocument = (sourceId) => {
    return Axios.get(EndPoints.Get_financeArchiveDocumentDownload(sourceId), { responseType: 'blob' });
};

export const DownloadFinanceArchiveFile = (gridFsId) => {
    return Axios.get(EndPoints.Get_financeArchiveFileDownload(gridFsId), { responseType: 'blob' });
};

